import React from 'react';
import Avatar from '@material-ui/core/Avatar';

/**
 * Render a simple item of a calendar event.
 * The avatar and the name of the person.
 */
class CalendarItem extends React.Component {
    render() {
        const { owner } = this.props.event.leavePeriod;

        return (
            <div className="calendar-vacations__item calendar-vacations-item">
                {owner.picture && (
                    <Avatar alt={owner.lastName} src={owner.picture.href} />
                )}
                <div className="calendar-vacations-item__owner">
                    <div>{owner.lastName}</div>
                    <div>{owner.firstName}</div>
                </div>
            </div>
        );
    }
}

export default CalendarItem;



// WEBPACK FOOTER //
// ./src/components/Calendar/CalendarItem.js